import React from "react";
import "./ChooseLocation.scss";
import { BiStore } from "react-icons/bi";
import { BsChevronRight } from "react-icons/bs";
import { useSelector } from "react-redux";

const ChooseLocation = (props) => {
  const places = useSelector((state) => state.widget.manyPlaces);

  return (
    <div
      className="ChooseLocation"
      ref={props.refr}
      onScroll={props.handleScroll}
    >
      {places.map((elem) => (
        <div className="singleStore" onClick={() => props.nextStep(elem.id)}>
          <div className="left">
            <div className="storeLogo">
              <BiStore />
            </div>
            <div className="storeInfo">
              <h1>{elem.name}</h1>
              <p>{elem.address}</p>
            </div>
          </div>
          <BsChevronRight />
        </div>
      ))}
    </div>
  );
};

export default ChooseLocation;
